//@ts-nocheck
import { t } from '@web-solutions/module-localization';

import { Text } from 'core/ui-elements';
import { useRemoteConfig } from 'core/hooks/use-remote-config';

import { Base } from '../base';

import classes from '../../style.module.scss';
import { IMAGES } from '../../images';

const tKey = 'core.subscription.error_popup.decline_reasons.card_issuer_law';

interface Props {
  onClick: () => void;
}

export const CardIssuerLaw: React.FC<Props> = ({ onClick }) => {
  const { policyLinks } = useRemoteConfig();

  const options = t(`${tKey}.options`, {
    returnObjects: true,
    descriptor: policyLinks.legalEntity,
  }) as unknown as string[];

  return (
    <Base subtitle={t(`${tKey}.subtitle`)} withButton withFooter onClick={onClick}>
      <>
        <Text className={classes.optionsTitle}>{t(`${tKey}.title`)}</Text>
        {options.map((option, indx) => {
          return (
            <>
              <Text
                className={classes.option}
                components={{ b: <span className={classes.highlight} /> }}
              >
                {`${indx + 1} ${option}`}
              </Text>
              {indx === 0 && (
                <>
                  <img
                    className={classes.amountLimitCardImage}
                    src={IMAGES.IMAGE_CARD.src}
                    srcSet={IMAGES.IMAGE_CARD.srcSet}
                    alt='card'
                  />
                </>
              )}
            </>
          );
        })}
      </>
    </Base>
  );
};
